import React, { Component } from "react";

class LeftBox extends Component {
	render() {
		let actors = [
			...this.props.actors.clients,
			...this.props.actors.inActors
		];
		let currentActor = actors.find(actor => actor.id === this.props.actor);

		return (
			<div className="chat-box-left clear-all">
				<div className="actor-img-name">
					<img src={currentActor.gravatar} className="chat-img" />
					<div>{currentActor.first_name}</div>
				</div>
				<div className="chat-box-text">{this.props.children}</div>
			</div>
		);
	}
}

export default LeftBox;



// WEBPACK FOOTER //
// /src/call/container/boxes/LeftBox.js